
export const blogCategories = [
  'Tất cả',
  'Chính sách',
  'Cuộc sống',
  'Kinh nghiệm',
  'Thủ tục',
  'Giáo dục',
];

export const blogPosts = [
  {
    id: 'chinh-sach-dinh-cu-latvia-2025',
    title: 'Chính Sách Định Cư Latvia 2025: Những Thay Đổi Quan Trọng Nhà Đầu Tư Cần Biết',
    excerpt: 'Tổng hợp các thay đổi mới nhất trong chính sách định cư Latvia năm 2025, bao gồm mức đầu tư tối thiểu, thời gian xử lý hồ sơ và quyền lợi mở rộng cho nhà đầu tư.',
    category: 'Chính sách',
    date: '15/01/2025',
    readTime: '8 phút đọc',
    views: 3420,
    image: 'https://public.readdy.ai/ai/img_res/ee99cca26d0fa557ac4fa33818cc06d4.jpg',
    featured: true,
    content: `<p>Năm 2025 đánh dấu nhiều thay đổi quan trọng trong chính sách <strong>định cư Latvia</strong> thông qua đầu tư. Chính phủ Latvia đã ban hành một số điều chỉnh nhằm thu hút thêm nhà đầu tư quốc tế, đặc biệt từ khu vực châu Á.</p>
    <h3>1. Mức Đầu Tư Tối Thiểu</h3>
    <p>Mức đầu tư tối thiểu để nhận <strong>thẻ tạm trú Latvia</strong> vẫn được duy trì ở mức 50.000 EUR cho hình thức đầu tư vào doanh nghiệp. Đây là mức đầu tư hấp dẫn so với nhiều quốc gia châu Âu khác trong khu vực Schengen.</p>
    <h3>2. Thời Gian Xử Lý Hồ Sơ</h3>
    <p>Thời gian xử lý hồ sơ <strong>đầu tư định cư Latvia</strong> đã được rút ngắn xuống còn 30-60 ngày làm việc, nhanh hơn đáng kể so với năm trước. Điều này giúp các nhà đầu tư có thể nhanh chóng hoàn tất thủ tục và bắt đầu cuộc sống mới tại châu Âu.</p>
    <h3>3. Quyền Lợi Mở Rộng</h3>
    <p>Người sở hữu thẻ tạm trú Latvia giờ đây được hưởng thêm nhiều quyền lợi, bao gồm quyền tiếp cận hệ thống giáo dục công lập miễn phí cho con em và bảo hiểm y tế cơ bản. Đây là bước tiến lớn trong việc hỗ trợ cộng đồng người nước ngoài <strong>định cư châu Âu</strong>.</p>
    <h3>4. Gia Hạn Thẻ Tạm Trú</h3>
    <p>Quy trình gia hạn thẻ tạm trú được đơn giản hóa, cho phép gia hạn trực tuyến mà không cần phải có mặt trực tiếp tại Latvia. Thẻ tạm trú có thời hạn 5 năm và có thể gia hạn không giới hạn.</p>`,
  },
  {
    id: 'cuoc-song-nguoi-viet-tai-riga',
    title: 'Cuộc Sống Người Việt Tại Riga: Từ Ẩm Thực Đến Cộng Đồng',
    excerpt: 'Khám phá cuộc sống thực tế của cộng đồng người Việt Nam tại thủ đô Riga, Latvia - từ ẩm thực quen thuộc tại Asian Alley đến các hoạt động cộng đồng sôi nổi.',
    category: 'Cuộc sống',
    date: '10/01/2025',
    readTime: '6 phút đọc',
    views: 2850,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20European%20cafe%20street%20scene%20in%20Riga%20Latvia%20with%20warm%20ambient%20lighting%20people%20enjoying%20outdoor%20dining%20beautiful%20old%20town%20architecture%20autumn%20atmosphere&width=800&height=500&seq=blog002&orientation=landscape',
    featured: false,
    content: `<p>Riga, thủ đô của Latvia, đang trở thành điểm đến ngày càng phổ biến cho cộng đồng người Việt Nam muốn <strong>định cư châu Âu</strong>. Với chi phí sinh hoạt hợp lý và chất lượng cuộc sống cao, Riga mang đến một môi trường sống lý tưởng.</p>
    <h3>Ẩm Thực Việt Tại Riga</h3>
    <p>Nhờ sự phát triển của chuỗi siêu thị <strong>Asian Alley</strong>, người Việt tại Riga có thể dễ dàng tìm mua các nguyên liệu nấu ăn quen thuộc. Từ nước mắm, phở, bún đến các loại rau củ châu Á đều có sẵn.</p>
    <h3>Cộng Đồng Người Việt</h3>
    <p>Cộng đồng người Việt tại Latvia ngày càng đông đảo và gắn kết. Các hoạt động văn hóa, lễ hội truyền thống được tổ chức thường xuyên, giúp duy trì bản sắc văn hóa Việt Nam ngay tại trái tim châu Âu.</p>`,
  },
  {
    id: 'so-sanh-chi-phi-dinh-cu-chau-au',
    title: 'So Sánh Chi Phí Định Cư Latvia Với Các Nước Châu Âu Khác',
    excerpt: 'Phân tích chi tiết chi phí định cư Latvia so với Bồ Đào Nha, Hy Lạp, Malta và các quốc gia EU khác. Tại sao Latvia là lựa chọn tối ưu cho người Việt?',
    category: 'Kinh nghiệm',
    date: '05/01/2025',
    readTime: '10 phút đọc',
    views: 4100,
    image: 'https://readdy.ai/api/search-image?query=European%20map%20with%20golden%20pins%20marking%20different%20countries%20elegant%20flat%20lay%20style%20with%20passport%20and%20euro%20currency%20notes%20warm%20lighting%20professional%20financial%20planning%20concept&width=800&height=500&seq=blog003&orientation=landscape',
    featured: false,
    content: `<p>Khi quyết định <strong>định cư châu Âu</strong>, chi phí là một trong những yếu tố quan trọng nhất. Bài viết này so sánh chi tiết chi phí <strong>định cư Latvia</strong> với các chương trình tương tự tại các quốc gia EU khác.</p>
    <h3>Latvia vs Bồ Đào Nha</h3>
    <p>Chương trình Golden Visa Bồ Đào Nha yêu cầu đầu tư tối thiểu 500.000 EUR vào bất động sản, gấp 10 lần so với mức đầu tư tối thiểu 50.000 EUR tại Latvia.</p>
    <h3>Latvia vs Hy Lạp</h3>
    <p>Hy Lạp yêu cầu đầu tư bất động sản từ 250.000 EUR. Mặc dù thấp hơn Bồ Đào Nha, nhưng vẫn cao hơn đáng kể so với Latvia.</p>`,
  },
  {
    id: 'thu-tuc-ho-so-dinh-cu-latvia',
    title: 'Hướng Dẫn Chuẩn Bị Hồ Sơ Định Cư Latvia Từ A-Z',
    excerpt: 'Danh sách đầy đủ các giấy tờ cần thiết, quy trình công chứng, dịch thuật và nộp hồ sơ xin thẻ tạm trú Latvia cho nhà đầu tư Việt Nam.',
    category: 'Thủ tục',
    date: '28/12/2024',
    readTime: '12 phút đọc',
    views: 5200,
    image: 'https://readdy.ai/api/search-image?query=Professional%20document%20preparation%20desk%20with%20passport%20visa%20application%20forms%20elegant%20pen%20and%20official%20stamps%20warm%20office%20lighting%20clean%20organized%20workspace&width=800&height=500&seq=blog004&orientation=landscape',
    featured: false,
    content: `<p>Chuẩn bị hồ sơ <strong>định cư Latvia</strong> đúng và đầy đủ là bước quan trọng nhất trong quá trình xin <strong>thẻ tạm trú</strong>. Bài viết này hướng dẫn chi tiết từng bước.</p>
    <h3>Danh Sách Giấy Tờ Cần Thiết</h3>
    <p>1. Hộ chiếu còn hạn ít nhất 12 tháng<br/>2. Lý lịch tư pháp (không quá 6 tháng)<br/>3. Giấy chứng nhận tài chính<br/>4. Hợp đồng đầu tư<br/>5. Bảo hiểm y tế quốc tế</p>`,
  },
  {
    id: 'he-thong-giao-duc-latvia',
    title: 'Hệ Thống Giáo Dục Latvia: Cơ Hội Học Tập Cho Con Em Người Việt',
    excerpt: 'Tìm hiểu hệ thống giáo dục Latvia từ mầm non đến đại học, các trường quốc tế tại Riga và quyền lợi giáo dục cho con em người định cư.',
    category: 'Giáo dục',
    date: '20/12/2024',
    readTime: '7 phút đọc',
    views: 2300,
    image: 'https://readdy.ai/api/search-image?query=Modern%20European%20university%20campus%20with%20students%20walking%20beautiful%20architecture%20green%20campus%20warm%20autumn%20lighting%20elegant%20educational%20institution%20building&width=800&height=500&seq=blog005&orientation=landscape',
    featured: false,
    content: `<p>Một trong những lý do hàng đầu khiến các gia đình Việt Nam chọn <strong>định cư Latvia</strong> là hệ thống giáo dục chất lượng cao của quốc gia này.</p>
    <h3>Giáo Dục Mầm Non & Tiểu Học</h3>
    <p>Latvia cung cấp giáo dục miễn phí cho trẻ em từ 5 tuổi. Các trường mầm non và tiểu học tại Riga có chất lượng giảng dạy cao với đội ngũ giáo viên được đào tạo bài bản.</p>`,
  },
  {
    id: 'kinh-nghiem-dinh-cu-thanh-cong',
    title: 'Chia Sẻ Kinh Nghiệm: Hành Trình Định Cư Latvia Của Gia Đình Anh Minh',
    excerpt: 'Câu chuyện thực tế từ gia đình anh Minh - từ quyết định đầu tư đến nhận thẻ tạm trú và bắt đầu cuộc sống mới tại Riga chỉ trong 5 tháng.',
    category: 'Kinh nghiệm',
    date: '15/12/2024',
    readTime: '9 phút đọc',
    views: 6800,
    image: 'https://readdy.ai/api/search-image?query=Happy%20Asian%20family%20walking%20in%20beautiful%20European%20old%20town%20Riga%20Latvia%20cobblestone%20streets%20warm%20golden%20hour%20lighting%20joyful%20atmosphere%20elegant%20architecture&width=800&height=500&seq=blog006&orientation=landscape',
    featured: false,
    content: `<p>Anh Minh, 38 tuổi, đến từ TP.HCM, đã hoàn tất quá trình <strong>định cư Latvia</strong> chỉ trong 5 tháng. Dưới đây là câu chuyện của anh.</p>
    <h3>Quyết Định Đầu Tư</h3>
    <p>"Sau khi tìm hiểu nhiều chương trình <strong>đầu tư định cư châu Âu</strong>, tôi chọn Latvia vì chi phí hợp lý và quy trình nhanh chóng. Đầu tư vào Asian Alley giúp tôi yên tâm vì đây là doanh nghiệp thực tế đang hoạt động tốt."</p>`,
  },
  {
    id: 'mua-dong-tai-latvia',
    title: 'Mùa Đông Tại Latvia: Hướng Dẫn Thích Nghi Cho Người Việt Mới Định Cư',
    excerpt: 'Mùa đông Latvia kéo dài và lạnh, nhưng với sự chuẩn bị đúng cách, bạn hoàn toàn có thể tận hưởng vẻ đẹp tuyết trắng của xứ sở Baltic.',
    category: 'Cuộc sống',
    date: '08/12/2024',
    readTime: '5 phút đọc',
    views: 1900,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20winter%20scene%20in%20Riga%20Latvia%20with%20snow%20covered%20old%20town%20buildings%20Christmas%20market%20warm%20street%20lights%20cozy%20European%20winter%20atmosphere&width=800&height=500&seq=blog007&orientation=landscape',
    featured: false,
    content: `<p>Mùa đông là thử thách lớn nhất với người Việt khi <strong>định cư Latvia</strong>. Nhiệt độ có thể xuống -20°C, nhưng với sự chuẩn bị đúng cách, bạn sẽ thích nghi nhanh chóng.</p>`,
  },
  {
    id: 'quyen-loi-y-te-dinh-cu-latvia',
    title: 'Quyền Lợi Y Tế Khi Định Cư Latvia: Bảo Hiểm & Dịch Vụ Chăm Sóc Sức Khỏe',
    excerpt: 'Tổng quan về hệ thống y tế Latvia, quyền lợi bảo hiểm sức khỏe cho người có thẻ tạm trú và các bệnh viện quốc tế tại Riga.',
    category: 'Chính sách',
    date: '01/12/2024',
    readTime: '6 phút đọc',
    views: 2100,
    image: 'https://readdy.ai/api/search-image?query=Modern%20European%20hospital%20building%20with%20clean%20architecture%20warm%20lighting%20professional%20healthcare%20facility%20exterior%20green%20landscaping%20elegant%20medical%20center&width=800&height=500&seq=blog008&orientation=landscape',
    featured: false,
    content: `<p>Hệ thống y tế là yếu tố quan trọng khi quyết định <strong>định cư Latvia</strong>. Latvia có hệ thống chăm sóc sức khỏe hiện đại đạt tiêu chuẩn EU.</p>`,
  },
  {
    id: 'co-hoi-kinh-doanh-tai-latvia',
    title: 'Cơ Hội Kinh Doanh Tại Latvia Cho Nhà Đầu Tư Việt Nam',
    excerpt: 'Phân tích các ngành nghề tiềm năng, môi trường kinh doanh và lợi thế cạnh tranh khi khởi nghiệp tại Latvia cho doanh nhân Việt.',
    category: 'Kinh nghiệm',
    date: '25/11/2024',
    readTime: '11 phút đọc',
    views: 3600,
    image: 'https://readdy.ai/api/search-image?query=Modern%20business%20district%20in%20Riga%20Latvia%20with%20glass%20office%20buildings%20warm%20sunset%20lighting%20professional%20corporate%20atmosphere%20European%20business%20center&width=800&height=500&seq=blog009&orientation=landscape',
    featured: false,
    content: `<p>Latvia không chỉ là điểm đến <strong>định cư</strong> mà còn mang đến nhiều cơ hội kinh doanh hấp dẫn cho nhà đầu tư Việt Nam.</p>`,
  },
];
